// These are currently all adhoc and will be mapped onto fields in the backend.
// What these values are on the client are not important, as long as they are documented and mapped in the backend.
// Reference: https://github.com/TinderBackend/revive.streaming/blob/main/flink/hubblestatejob/src/main/resources/config/ui_components/shared/paywall/paywall_dialog.json

// Paywall
export const HUBBLE_ID_PAYWALL_DIALOG_OPEN = 'cefc8527-9a63';
export const HUBBLE_ID_PAYWALL_DIALOG_CLOSE = '2a0c4b15-4caf';
export const HUBBLE_ID_PAYWALL_OPTION_ACCEPT_BUTTON = '4970853c-6162';
export const HUBBLE_ID_PAYWALL_OPTION_SELECT_BUTTONS = 'e9735f31-c0a0';
export const HUBBLE_ID_PRECHECKOUT_PAYWALL_OPEN = 'd5741765-0648';
export const HUBBLE_ID_PRECHECKOUT_PAYWALL_CLOSE = '159fff86-beec';
export const HUBBLE_ID_PRECHECKOUT_PAYWALL_ACCEPT_BUTTON = '499c9bc0-0fd7';
export const HUBBLE_ID_PRECHECKOUT_FEATURE_SELECT_BUTTON = 'bbd4e39c-6a73';
export const HUBBLE_ID_SUPERBOOST_PAYWALL_DIALOG_OPEN = '879842ef-2e42';
export const HUBBLE_ID_SUPERBOOST_PAYWALL_DIALOG_CLOSE = '4fcb1c46-b11b';
export const HUBBLE_ID_SUPERBOOST_PAYWALL_OPTION_ACCEPT_BUTTON = '0b5310f5-a211';
export const HUBBLE_ID_SUPERBOOST_PAYWALL_OPTION_SELECT_BUTTONS = '689d025c-59e1';

// Read Receipts
export const HUBBLE_ID_READ_RECEIPT_MESSAGE_BUTTON = 'f5af9a0c-ff41';
export const HUBBLE_ID_READ_RECEIPT_NOMESSAGE_BUTTON = '258bc088-a962';

// Tinder Plus
export const HUBBLE_ID_GAMEPAD_REWIND_BUTTON = 'f18643a1-0631';
export const HUBBLE_ID_PROFILE_MOBILE_COVER_TINDER_PLUS_PAYWALL_BUTTON = '0f2bcd60-5e18';
export const HUBBLE_ID_PROFILE_AGE_TOGGLE = '465eae51-e3cc';
export const HUBBLE_ID_PROFILE_DISTANCE_TOGGLE = 'ac74ce16-e81f';
export const HUBBLE_ID_PROFILE_WHO_YOU_SEE_TOGGLE = 'e61e3d9a-9fdc';
export const HUBBLE_ID_PROFILE_WHO_SEES_YOU_TOGGLE = '47024e53-b497';
export const HUBBLE_ID_MOBILE_SETTINGS_TINDER_PLUS_BUTTON = '6b89d4f4-4ac9';
export const HUBBLE_ID_DESKTOP_SETTINGS_TINDER_PLUS_BUTTON = '27ec9ea7-72dc';
export const HUBBLE_ID_OUT_OF_LIKES_ALTERNATE_SUBSCRIPTION_BUTTON = 'a2af56ba-d833';
export const HUBBLE_ID_PASSPORT_ADD_OR_SET_BUTTON = 'a1e82644-c70a';
export const HUBBLE_ID_PLATINUM_PAYWALL_BACK_TO_PLUS_BUTTON = '11c36035-2516';

// Tinder Plus + Gold
export const HUBBLE_ID_BOOST_END_MODAL_ACCEPT_BUTTON = 'de473784-4a82';
export const HUBBLE_ID_BOOST_PAYWALL_ALTERNATE_SUBSCRIPTION_BUTTON = '448a719d-9a01';
export const HUBBLE_ID_ACTIVE_BOOST_GAMEPAD_BOOST_BUTTON = 'a7375ee1-dd91';
export const HUBBLE_ID_ACTIVE_BOOST_MODAL_ACCEPT_BUTTON = '8f3174f8-4e09';
export const HUBBLE_ID_SUPERLIKE_PAYWALL_ALC_DISABLED = 'f8f22791-fb99';
export const HUBBLE_ID_SUPERLIKE_PAYWALL_ALTERNATE_SUBSCRIPTION_BUTTON = '6c509b64-da05';
export const HUBBLE_ID_OUT_OF_LIKES_UPSELL_ACTION = 'ede0ffe4-b671';

// Boost
export const HUBBLE_ID_GAMEPAD_BOOST_BUTTON = '97e1d5c8-a6bb';
export const HUBBLE_ID_BOOST_CONSUMABLE_BADGE_BUTTON = 'fa0a1390-aa8e';
export const HUBBLE_ID_BOOST_UPSELL_MATCH_GRID_DESKTOP_BUTTON = '2438e3a6-4f7b';
export const HUBBLE_ID_BOOST_UPSELL_MATCH_LIST_MOBILE_BUTTON = '00c8881e-58dc';
export const HUBBLE_ID_SUPERBOOST_BACK_TO_BOOST_BUTTON = '1b57be94-87f4';
export const HUBBLE_ID_BOOST_UPSELL_REVENUE_HOOK = 'ea5c109a-94e4';
export const HUBBLE_ID_BOOST_UPSELL_REVENUE_HOOK_ACCEPT_BUTTON = 'd53a3bd3-2101';
export const HUBBLE_ID_BOOST_UPSELL_OUT_OF_RECS_BUTTON = '2222688c-f499';
export const HUBBLE_ID_BOOST_START_BOOST_SAGA_INSUFFICIENT = 'd745ae7e-d1a4';

// Superlike
export const HUBBLE_ID_SUPERLIKE_CONSUMABLE_BADGE_BUTTON = '1b3f39ca-ad48';
export const HUBBLE_ID_LIKESYOU_SUPERLIKE_GAMEPAD_BUTTON = 'abc5639c-49f3';
export const HUBBLE_ID_MYLIKES_SUPERLIKE_GAMEPAD_BUTTON = 'd626a46c-9557';
export const HUBBLE_ID_SWIPENOTEMODAL_OUT_OF_SUPERLIKE_GAMEPAD_BUTTON = 'e9b1a358-5951';
export const HUBBLE_ID_SWIPENOTEMODAL_OUT_OF_SUPERLIKE_SWIPE_UP = 'a30ab920-c9b4';
export const HUBBLE_ID_SUPERLIKE_EXHAUSTED = '4b99a486-9368';
export const HUBBLE_ID_RECS_SUPERLIKE_HIGH_RSRR_UPSELL = 'b70dd3f0-fb29';

// Superboost
export const HUBBLE_ID_SUPERBOOST_BOOST_AGAIN_ALTERNATE_UNLOCK_BUTTON = '8101d233-250c';
export const HUBBLE_ID_BOOST_PAYWALL_ALTERNATE_SUPERBOOST_BUTTON = '85113415-0707';
export const HUBBLE_ID_SUPERBOOST_END_MODAL_ACCEPT_BUTTON = 'ec43e5cb-aa59';
export const HUBBLE_ID_SUPERBOOST_ENTRY_BUTTON = '390e28cb-af15';

// Tinder Gold
export const HUBBLE_ID_GOLD_CONSUMABLE_BADGE_BUTTON = 'f67df540-bb5b';
export const HUBBLE_ID_QUICKFILTERS_BUTTON = 'fb81ccac-aac2';
export const HUBBLE_ID_FILTERTRAY_APPLY_BUTTON = '32dfa4b6-f8a8';
export const HUBBLE_ID_MOBILE_LIKESYOU_MATCHLISTITEM_BUTTON = '668d7a6c-0be0';
export const HUBBLE_ID_PLATINUM_PAYWALL_BACK_TO_GOLD_BUTTON = '47864f4e-8052';
export const HUBBLE_ID_MESSAGE_RECENTLYACTIVE_BUTTON = '45c14135-48af';
export const HUBBLE_ID_INTROPRICE_GOLD_BANNER_BUTTON = 'edf2f961-d400';
export const HUBBLE_ID_TEASERGRID_GOLD_RECS_BUTTON = '6319d873-ced0';
export const HUBBLE_ID_TEASERGRID_GOLD_SCROLL_ACTION = 'cc24b0e6-1b20';
export const HUBBLE_ID_LIKESYOU_GOLD_CTA_BUTTON = '3cfedc2e-4983';
export const HUBBLE_ID_CELEBRATION_LIKES_CONTINUE_BUTTON = '6d3bbdfe-43b5';
export const HUBBLE_ID_MERCHANDISING_FEATURE_BUTTON = '0122711b-fd72';
export const HUBBLE_ID_MOBILE_SETTINGS_TINDER_GOLD_BUTTON = 'd2fe0569-4928';
export const HUBBLE_ID_DESKTOP_SETTINGS_TINDER_GOLD_BUTTON = '3e21e5f1-e711';
export const HUBBLE_ID_PROFILE_MOBILE_COVER_TINDER_GOLD_PAYWALL_BUTTON = '669b2f6b-f7b7';
export const HUBBLE_ID_GOLD_DEEPLINK = '1d0de416-0e36';

// Tinder Platinum
export const HUBBLE_ID_PLATINUM_CONSUMABLE_BADGE_BUTTON = '7dc34206-fe9b';
export const HUBBLE_ID_MODULAR_PLATINUM_UPGRADE_LIKES_BUTTON = 'ac1c03e9-f361';
export const HUBBLE_ID_MATCHLIST_PLATINUM_BANNER_BUTTON = '7658dcdc-1d84';
export const HUBBLE_ID_LIKESYOU_PLATINUM_CTA_BUTTON = '99419318-baf2';
export const HUBBLE_ID_PRIORITY_LIKES_MODAL_ACCEPT_BUTTON = 'fce87bc6-bf1c';
export const HUBBLE_ID_SWIPENOTEMODAL_MYLIKES_SEND_BUTTON = 'ed0bd780-8508';
export const HUBBLE_ID_SWIPENOTEMODAL_SEND_BUTTON = 'c9ad8009-9ec2';
export const HUBBLE_ID_MYLIKES_UPSELL_ACCEPT_BUTTON = '46c6d82e-efce';
export const HUBBLE_ID_PROFILE_MOBILE_COVER_TINDER_PLATINUM_PAYWALL_BUTTON = 'd9287cc5-9cb5';
export const HUBBLE_ID_OUT_OF_LIKES_GOLD_BOUNCER_ALTERNATIVE_SUBSCRIPTION_BUTTON = 'bc3d0d76-c4a2';
export const HUBBLE_ID_OUT_OF_LIKES_PLATINUM_BOUNCER_ALTERNATIVE_SUBSCRIPTION_BUTTON =
  '6342d806-7ac8';
export const HUBBLE_ID_MOBILE_SETTINGS_TINDER_PLATINUM_BUTTON = 'c2b56cac-39ad';
export const HUBBLE_ID_DESKTOP_SETTINGS_TINDER_PLATINUM_BUTTON = '9e33acdf-28a8';

// Recs
export const HUBBLE_ID_RECS_SWIPE_LEFT = '82c838cc-2772';
export const HUBBLE_ID_RECS_SWIPE_RIGHT = 'efaf5615-a340';
export const HUBBLE_ID_RECS_SWIPE_UP = '0b5ded3b-2471';
export const HUBBLE_ID_RECS_REWIND_BUTTON = 'ee2a4c1e-d65a';
export const HUBBLE_ID_RECS_PASS_BUTTON = '6fef3190-698c';
export const HUBBLE_ID_RECS_SUPERLIKE_BUTTON = 'd181ef6b-635b';
export const HUBBLE_ID_RECS_LIKE_BUTTON = 'cc085a8f-9857';
export const HUBBLE_ID_RECS_BOOST_BUTTON = 'a2182f2c-18a5';
export const HUBBLE_ID_RECS_CARD = '71cb7773-cee3';
export const HUBBLE_ID_RECS_CARD_PHOTO = 'a9dcfb53-9d0b';
export const HUBBLE_ID_RECS_CARD_PHOTO_LEFT = '699138b9-0b43';
export const HUBBLE_ID_RECS_CARD_PHOTO_RIGHT = 'c2fe8f19-8abf';
export const HUBBLE_ID_RECS_CARD_PROFILE_BUTTON = 'c3346576-f21a';
export const HUBBLE_ID_RECS_PROFILE_PASS_BUTTON = '6d9586cc-dbcd';
export const HUBBLE_ID_RECS_PROFILE_SUPERLIKE_BUTTON = '6ff6f6b7-c6ff';
export const HUBBLE_ID_RECS_PROFILE_LIKE_BUTTON = '618d58a5-5191';
export const HUBBLE_ID_RECS_PROFILE_CLOSE_BUTTON = '74d04c39-57f6';
export const HUBBLE_ID_RECS_PROFILE_CARD = 'd73dd06b-05d7';
export const HUBBLE_ID_RECS_PROFILE_PHOTO = 'c1f99c07-3ee7';
export const HUBBLE_ID_RECS_PROFILE_PHOTO_LEFT = '7ce57cde-52c0';
export const HUBBLE_ID_RECS_PROFILE_PHOTO_RIGHT = 'fb1a0e9a-64fc';
export const HUBBLE_ID_GRID_ITEM_PROFILE_OPEN_BUTTON = 'd1f32d17-3261';

// Screens
export const HUBBLE_ID_RECS_SCREEN = '528b45cb-7b4d';
export const HUBBLE_ID_EXPLORE_SCREEN = '36661b47-e031';
export const HUBBLE_ID_PREMIUM_HOME_SCREEN = 'd9bb2add-cbc2';
export const HUBBLE_ID_CHAT_SCREEN = 'e27b3492-1f68';
export const HUBBLE_ID_DESKTOP_MATCHLIST_SCREEN = '84129196-1575';
export const HUBBLE_ID_MOBILE_MATCHLIST_SCREEN = '3cefdae9-69db';
export const HUBBLE_ID_DESKTOP_PROFILE_SCREEN = '6a2a7e0e-ff98';
export const HUBBLE_ID_MOBILE_PROFILE_SCREEN = '89b803a4-e1bb';
export const HUBBLE_ID_RECS_CARDBOARD_SCREEN = 'fc6618a8-399a';
export const HUBBLE_ID_RECS_PROFILE_SCREEN = '8ed36a27-f1a7';
export const HUBBLE_ID_MYLIKES_SCREEN = 'd5fa3eda-2361';
export const HUBBLE_ID_LIKESSENT_SCREEN = 'eab24bf5-04f7';

// Auth
export const HUBBLE_ID_APPEAL_CENTER_BUTTON = '102cb29a-d3a9';
export const HUBBLE_ID_AUTH_COMPLETION_SCREEN = 'e42f8208-ca77';
export const HUBBLE_ID_BAN_SCREEN = '80918760-f410';
export const HUBBLE_ID_COLLECT_EMAIL_SCREEN = '04932e76-6fef';
export const HUBBLE_ID_COLLECT_EMAIL_CONTINUE_BUTTON = '4d2dd107-6fe9';
export const HUBBLE_ID_COLLECT_EMAIL_GOOGLE_BUTTON = 'df0e252b-4bb0';
export const HUBBLE_ID_CUSTOM_BAN_SCREEN = '058d38a6-bc8f';
export const HUBBLE_ID_PHONE_NUMBER_SCREEN = '688aed58-e895';
export const HUBBLE_ID_PHONE_NUMBER_CONTINUE_BUTTON = 'ed0dbeeb-1aa2';
export const HUBBLE_ID_PHONE_OTP_SCREEN = '17df493f-522c';
export const HUBBLE_ID_PHONE_OTP_CONTINUE_BUTTON = '856a3965-d57e';
export const HUBBLE_ID_PUSH_AUTH_VERIFICATION_SCREEN = '8455a486-8bf2';
export const HUBBLE_ID_SIGN_IN_SCREEN = '93072602-53c0';
export const HUBBLE_ID_SIGN_IN_GOOGLE_BUTTON = 'fc144b10-57c5';
export const HUBBLE_ID_SIGN_IN_FACEBOOK_BUTTON = 'e3e534a7-ea5c';
export const HUBBLE_ID_SIGN_IN_PHONE_NUMBER_BUTTON = '55214ce0-a934';
export const HUBBLE_ID_WELCOME_BACK_SCREEN = '91e906c9-2f7c';
export const HUBBLE_ID_WELCOME_BACK_LOGIN_BUTTON = '6cda8fdd-cc25';
export const HUBBLE_ID_WELCOME_BACK_TEXT = '42af43ad-4b3c';

// Selfie Challenge V2 Screens
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_ENTRY = 'F2FF26B3-05A7';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_UNDER_REVIEW = '38055554-BDB6';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_HOW_IT_WORKS = 'A2388D9D-B23A';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_DATA_EXPLANATION = '1ADF4062-D90D';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_SELECTION = 'CDC699EE-BB3A';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_EDUCATION = '6261BF32-D68C';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_CONNECTION_ERROR = '68BC5CD5-E946';

// Selfie Challenge V2 Actions
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_ENTRY_CTA = '8C8C0935-59A7';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_1_CTA = 'D11216B3-5860';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_1_EXIT = '2AE70E06-970A';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_2_CTA = '6F55D934-A212';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_2_EXIT = '6F3D28D3-D5E0';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_2_PREVIOUS = '64c90f60-f8bb';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_MORE_DETAILS = '4f71f1b4-7b13';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_CTA = '6ff76ab7-8722';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_PREVIOUS = '728a6193-5d5f';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_EXIT = 'f0d82a7e-5a89';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_LEARN_MORE = 'aa10f728-35a4';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_EDUCATION_START = '07BAC049-37E3';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_EDUCATION_EXIT = '2988bd90-e8d0';

// Selfie Challenge V2 FaceTec
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_FACE_TEC_USER_CANCEL = 'ab7e2503-7586';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_FACE_TEC_INITIALIZED = '76a8c6ca-6b54';
export const HUBBLE_ID_SELFIE_V2_CHALLENGE_FACE_TEC_SUCCESS = '00b31333-7e86';

// MFP
export const HUBBLE_ID_MANDATED_FACE_PHOTO_PROFILE_WARNING = '1aac01a6-5ac5';
export const HUBBLE_ID_MANDATED_FACE_PHOTO_PROFILE_WARNING_TAP = 'e78794f1-a23f';
export const HUBBLE_ID_MANDATED_FACE_PHOTO_LEARN_MORE_BUTTON = '05846205-b90a';
export const HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL = 'c837da1a-c724';
export const HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL_ADD_PHOTO_BUTTON = '54b5e1f0-ee20';
export const HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL_DISMISS_BUTTON = '23c800a2-287c';
export const HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL_LEARN_MORE_BUTTON = 'cd5c7dfc-a740';

// Liveness Check - Camera Permission
export const HUBBLE_ID_LIVENESS_CHECK_CAMERA_PERMISSION_DISMISS = '3a0f23e1-6722';
export const HUBBLE_ID_LIVENESS_CHECK_CAMERA_PERMISSION_ALLOW = '14aea2cd-dbc1';

// Liveness Check - Onboarding Intro
export const HUBBLE_ID_LIVENESS_CHECK_ONBOARDING_INTRO_ENTRY = '560dcfac-4708';
export const HUBBLE_ID_LIVENESS_CHECK_ONBOARDING_INTRO_TAP_LEARN_MORE = '7834c8f5-ceb4';
export const HUBBLE_ID_LIVENESS_CHECK_ONBOARDING_INTRO_TAP_NEXT = '1aae7117-757b';

// Liveness Check - Education replaced by loading screen
export const HUBBLE_ID_LIVENESS_CHECK_ONBOARDING_LOADING_SCREEN = 'b9683895-715e';
export const HUBBLE_ID_LIVENESS_CHECK_POST_AUTH_LOADING_SCREEN = 'e371f5c8-8d29';

// Liveness Check - Facetec
export const HUBBLE_ID_LIVENESS_CHECK_FACETEC_ENTRY = '2d18d4d2-385b';
export const HUBBLE_ID_LIVENESS_CHECK_FACETEC_UPLOAD = 'd5fb9e41-c7f1';
export const HUBBLE_ID_LIVENESS_CHECK_FACETEC_TAP_CANCEL = '96eb2946-07f2';

// Liveness Check - Post auth intro
export const HUBBLE_ID_LIVENESS_CHECK_POSTAUTH_INTRO_ENTRY = '96b4aeec-8269';
export const HUBBLE_ID_LIVENESS_CHECK_POSTAUTH_INTRO_TAP_LEARN_MORE = '39071ce1-5133';
export const HUBBLE_ID_LIVENESS_CHECK_POSTAUTH_INTRO_TAP_NEXT = '40c605e7-c9a2';

// Liveness Check - Post auth education
export const HUBBLE_ID_LIVENESS_CHECK_POSTAUTH_EDUCATION_ENTRY = '565328fd-e36b';
export const HUBBLE_ID_LIVENESS_CHECK_POSTAUTH_EDUCATION_TAP_BACK = 'b1e8355c-883b';
export const HUBBLE_ID_LIVENESS_CHECK_POSTAUTH_EDUCATION_TAP_NEXT = '7656c38f-1219';

// Liveness Check - Celebration
export const HUBBLE_ID_LIVENESS_CHECK_CELEBRATION_ENTRY = '89a7345d-7787';
export const HUBBLE_ID_LIVENESS_CHECK_CELEBRATION_TAP_CTA = '77ac14ee-d8d0';

// Liveness Check - Consent
export const HUBBLE_ID_LIVENESS_CHECK_CONSENT_ENTRY = '157a7b08-c8ac';
export const HUBBLE_ID_LIVENESS_CHECK_CONSENT_TAP_AGREE = 'edcb060c-94e3';
export const HUBBLE_ID_LIVENESS_CHECK_CONSENT_TAP_LEARN_MORE = 'da556f5c-0d4d';

// ONBOARDING
export const HUBBLE_ID_ONBOARDING_AGE_RESTRICTED = '9807a310-4510';
export const HUBBLE_ID_ONBOARDING_BIRTHDAY = '685f67ce-ed36';
export const HUBBLE_ID_ONBOARDING_DISTANCE_PREFERENCE = '48c841ba-bf1e';
export const HUBBLE_ID_ONBOARDING_GENDER = '42557ea1-d9c2';
export const HUBBLE_ID_ONBOARDING_HOUSE_RULES = '00db7bf4-49fa';
export const HUBBLE_ID_ONBOARDING_INTERESTS = '2a19c2ef-cbfb';
export const HUBBLE_ID_ONBOARDING_LIFESTYLE_HABITS = 'd1143b1d-5093';
export const HUBBLE_ID_ONBOARDING_NAME = '7822c9fb-e5f5';
export const HUBBLE_ID_ONBOARDING_COMPLETION = 'f6abf66b-cfb7';
export const HUBBLE_ID_ONBOARDING_EXIT_MODAL = 'bdf69bc2-cdb7';
export const HUBBLE_ID_ONBOARDING_EXIT_MODAL_STAY_BUTTON = '158f5ce5-44e0';
export const HUBBLE_ID_ONBOARDING_EXIT_MODAL_LEAVE_BUTTON = '8f74404e-ee13';
export const HUBBLE_ID_ONBOARDING_STARTED = '593322b4-1fb8';
export const HUBBLE_ID_ONBOARDING_PHOTOS = '75ec0bfc-227a';
export const HUBBLE_ID_ONBOARDING_RELATIONSHIP_INTENT = 'f100634c-e3ad';
export const HUBBLE_ID_ONBOARDING_SCHOOL = 'ad0e1b15-0527';
export const HUBBLE_ID_ONBOARDING_SEXUAL_ORIENTATION = '8f6dd0ee-448a';
export const HUBBLE_ID_ONBOARDING_TARGET_GENDER = 'f457970b-9606';
export const HUBBLE_ID_ONBOARDING_SUBMIT_BUTTON = 'ec6e73c3-c311';
export const HUBBLE_ID_ONBOARDING_SKIP_BUTTON = 'd72f574f-193b';
export const HUBBLE_ID_ONBOARDING_BACK_BUTTON = 'e835f1a6-23da';

// Labels
export const HUBBLE_ID_LABELS = __DEVELOPMENT__
  ? {
      [HUBBLE_ID_PAYWALL_DIALOG_OPEN]: 'Paywall Dialog Open',
      [HUBBLE_ID_PAYWALL_DIALOG_CLOSE]: 'Paywall Dialog Close',
      [HUBBLE_ID_PAYWALL_OPTION_ACCEPT_BUTTON]: 'Paywall Option Accept Button',
      [HUBBLE_ID_PAYWALL_OPTION_SELECT_BUTTONS]: 'Paywall Option Select Buttons',
      [HUBBLE_ID_PRECHECKOUT_PAYWALL_OPEN]: 'Precheckout Paywall Open',
      [HUBBLE_ID_PRECHECKOUT_PAYWALL_CLOSE]: 'Precheckout Paywall Close',
      [HUBBLE_ID_PRECHECKOUT_PAYWALL_ACCEPT_BUTTON]: 'Precheckout Paywall Accept Button',
      [HUBBLE_ID_PRECHECKOUT_FEATURE_SELECT_BUTTON]: 'Precheckout Feature Select Button',
      [HUBBLE_ID_SUPERBOOST_PAYWALL_DIALOG_OPEN]: 'Superboost Paywall Dialog Open',
      [HUBBLE_ID_SUPERBOOST_PAYWALL_DIALOG_CLOSE]: 'Superboost Paywall Dialog Close',
      [HUBBLE_ID_SUPERBOOST_PAYWALL_OPTION_ACCEPT_BUTTON]:
        'Superboost Paywall Option Accept Button',
      [HUBBLE_ID_SUPERBOOST_PAYWALL_OPTION_SELECT_BUTTONS]:
        'Superboost Paywall Option Select Buttons',
      [HUBBLE_ID_READ_RECEIPT_MESSAGE_BUTTON]: 'Read Receipt Message Button',
      [HUBBLE_ID_READ_RECEIPT_NOMESSAGE_BUTTON]: 'Read Receipt NoMessage Button',
      [HUBBLE_ID_GAMEPAD_REWIND_BUTTON]: 'Gamepad Rewind Button',
      [HUBBLE_ID_PROFILE_MOBILE_COVER_TINDER_PLUS_PAYWALL_BUTTON]:
        'Profile Mobile Cover Tinder Plus Paywall Button',
      [HUBBLE_ID_PROFILE_AGE_TOGGLE]: 'Profile Age Toggle',
      [HUBBLE_ID_PROFILE_DISTANCE_TOGGLE]: 'Profile Distance Toggle',
      [HUBBLE_ID_PROFILE_WHO_YOU_SEE_TOGGLE]: 'Profile Who You See Toggle',
      [HUBBLE_ID_PROFILE_WHO_SEES_YOU_TOGGLE]: 'Profile Who Sees You Toggle',
      [HUBBLE_ID_MOBILE_SETTINGS_TINDER_PLUS_BUTTON]: 'Mobile Settings Tinder Plus Button',
      [HUBBLE_ID_DESKTOP_SETTINGS_TINDER_PLUS_BUTTON]: 'Desktop Settings Tinder Plus Button',
      [HUBBLE_ID_OUT_OF_LIKES_ALTERNATE_SUBSCRIPTION_BUTTON]:
        'Out of Likes Alternate Subscription Button',
      [HUBBLE_ID_PASSPORT_ADD_OR_SET_BUTTON]: 'Passport Add or Set Button',
      [HUBBLE_ID_PLATINUM_PAYWALL_BACK_TO_PLUS_BUTTON]: 'Platinum Paywall Back to Plus Button',
      [HUBBLE_ID_BOOST_END_MODAL_ACCEPT_BUTTON]: 'Boost End Modal Accept Button',
      [HUBBLE_ID_BOOST_PAYWALL_ALTERNATE_SUBSCRIPTION_BUTTON]:
        'Boost Paywall Alternate Subscription Button',
      [HUBBLE_ID_ACTIVE_BOOST_GAMEPAD_BOOST_BUTTON]: 'Active Boost Gamepad Boost Button',
      [HUBBLE_ID_ACTIVE_BOOST_MODAL_ACCEPT_BUTTON]: 'Active Boost Modal Accept Button',
      [HUBBLE_ID_SUPERLIKE_PAYWALL_ALC_DISABLED]: 'Superlike Paywall ALC Disabled',
      [HUBBLE_ID_SUPERLIKE_PAYWALL_ALTERNATE_SUBSCRIPTION_BUTTON]:
        'Superlike Paywall Alternate Subscription Button',
      [HUBBLE_ID_OUT_OF_LIKES_UPSELL_ACTION]: 'Out of Likes Upsell Action',
      [HUBBLE_ID_GAMEPAD_BOOST_BUTTON]: 'Gamepad Boost Button',
      [HUBBLE_ID_BOOST_CONSUMABLE_BADGE_BUTTON]: 'Boost Consumable Badge Button',
      [HUBBLE_ID_BOOST_UPSELL_MATCH_GRID_DESKTOP_BUTTON]: 'Boost Upsell Match Grid Desktop Button',
      [HUBBLE_ID_BOOST_UPSELL_MATCH_LIST_MOBILE_BUTTON]: 'Boost Upsell Match List Mobile Button',
      [HUBBLE_ID_SUPERBOOST_BACK_TO_BOOST_BUTTON]: 'Superboost Back to Boost Button',
      [HUBBLE_ID_BOOST_UPSELL_REVENUE_HOOK]: 'Boost Upsell Revenue Hook',
      [HUBBLE_ID_BOOST_UPSELL_REVENUE_HOOK_ACCEPT_BUTTON]:
        'Boost Upsell Revenue Hook Accept Button',
      [HUBBLE_ID_BOOST_UPSELL_OUT_OF_RECS_BUTTON]: 'Boost Upsell Out of Recs Button',
      [HUBBLE_ID_BOOST_START_BOOST_SAGA_INSUFFICIENT]: 'Boost Start Boost Saga Insufficient',
      [HUBBLE_ID_SUPERLIKE_CONSUMABLE_BADGE_BUTTON]: 'Superlike Consumable Badge Button',
      [HUBBLE_ID_LIKESYOU_SUPERLIKE_GAMEPAD_BUTTON]: 'LikesYou Superlike Gamepad Button',
      [HUBBLE_ID_MYLIKES_SUPERLIKE_GAMEPAD_BUTTON]: 'MyLikes Superlike Gamepad Button',
      [HUBBLE_ID_SWIPENOTEMODAL_OUT_OF_SUPERLIKE_GAMEPAD_BUTTON]:
        'SwipeNoteModal Out of Superlike Gamepad Button',
      [HUBBLE_ID_SWIPENOTEMODAL_OUT_OF_SUPERLIKE_SWIPE_UP]:
        'SwipeNoteModal Out of Superlike Swipe Up',
      [HUBBLE_ID_SUPERLIKE_EXHAUSTED]: 'Superlike Exhausted',
      [HUBBLE_ID_RECS_SUPERLIKE_HIGH_RSRR_UPSELL]: 'Recs Superlike High RSRR Upsell',
      [HUBBLE_ID_SUPERBOOST_BOOST_AGAIN_ALTERNATE_UNLOCK_BUTTON]:
        'Superboost Boost Again Alternate Unlock Button',
      [HUBBLE_ID_BOOST_PAYWALL_ALTERNATE_SUPERBOOST_BUTTON]:
        'Boost Paywall Alternate Superboost Button',
      [HUBBLE_ID_SUPERBOOST_END_MODAL_ACCEPT_BUTTON]: 'Superboost End Modal Accept Button',
      [HUBBLE_ID_SUPERBOOST_ENTRY_BUTTON]: 'Superboost Entry Button',
      [HUBBLE_ID_GOLD_CONSUMABLE_BADGE_BUTTON]: 'Gold Consumable Badge Button',
      [HUBBLE_ID_QUICKFILTERS_BUTTON]: 'QuickFilters Button',
      [HUBBLE_ID_FILTERTRAY_APPLY_BUTTON]: 'FilterTray Apply Button',
      [HUBBLE_ID_MOBILE_LIKESYOU_MATCHLISTITEM_BUTTON]: 'Mobile LikesYou MatchListItem Button',
      [HUBBLE_ID_PLATINUM_PAYWALL_BACK_TO_GOLD_BUTTON]: 'Platinum Paywall Back to Gold Button',
      [HUBBLE_ID_MESSAGE_RECENTLYACTIVE_BUTTON]: 'Message RecentlyActive Button',
      [HUBBLE_ID_INTROPRICE_GOLD_BANNER_BUTTON]: 'IntroPrice Gold Banner Button',
      [HUBBLE_ID_TEASERGRID_GOLD_RECS_BUTTON]: 'TeaserGrid Gold Recs Button',
      [HUBBLE_ID_TEASERGRID_GOLD_SCROLL_ACTION]: 'TeaserGrid Gold Scroll Action',
      [HUBBLE_ID_LIKESYOU_GOLD_CTA_BUTTON]: 'LikesYou Gold CTA Button',
      [HUBBLE_ID_CELEBRATION_LIKES_CONTINUE_BUTTON]: 'Celebration Likes Continue Button',
      [HUBBLE_ID_MERCHANDISING_FEATURE_BUTTON]: 'Merchandising Feature Button',
      [HUBBLE_ID_MOBILE_SETTINGS_TINDER_GOLD_BUTTON]: 'Mobile Settings Tinder Gold Button',
      [HUBBLE_ID_DESKTOP_SETTINGS_TINDER_GOLD_BUTTON]: 'Desktop Settings Tinder Gold Button',
      [HUBBLE_ID_PROFILE_MOBILE_COVER_TINDER_GOLD_PAYWALL_BUTTON]:
        'Profile Mobile Cover Tinder Gold Paywall Button',
      [HUBBLE_ID_GOLD_DEEPLINK]: 'Gold Deeplink',
      [HUBBLE_ID_PLATINUM_CONSUMABLE_BADGE_BUTTON]: 'Platinum Consumable Badge Button',
      [HUBBLE_ID_MODULAR_PLATINUM_UPGRADE_LIKES_BUTTON]: 'Modular Platinum Upgrade Likes Button',
      [HUBBLE_ID_MATCHLIST_PLATINUM_BANNER_BUTTON]: 'MatchList Platinum Banner Button',
      [HUBBLE_ID_LIKESYOU_PLATINUM_CTA_BUTTON]: 'LikesYou Platinum CTA Button',
      [HUBBLE_ID_PRIORITY_LIKES_MODAL_ACCEPT_BUTTON]: 'Priority Likes Modal Accept Button',
      [HUBBLE_ID_SWIPENOTEMODAL_MYLIKES_SEND_BUTTON]: 'SwipeNoteModal MyLikes Send Button',
      [HUBBLE_ID_SWIPENOTEMODAL_SEND_BUTTON]: 'SwipeNoteModal Send Button',
      [HUBBLE_ID_MYLIKES_UPSELL_ACCEPT_BUTTON]: 'MyLikes Upsell Accept Button',
      [HUBBLE_ID_PROFILE_MOBILE_COVER_TINDER_PLATINUM_PAYWALL_BUTTON]:
        'Profile Mobile Cover Tinder Platinum Paywall Button',
      [HUBBLE_ID_OUT_OF_LIKES_GOLD_BOUNCER_ALTERNATIVE_SUBSCRIPTION_BUTTON]:
        'Out of Likes Gold Bouncer Alternative Subscription Button',
      [HUBBLE_ID_OUT_OF_LIKES_PLATINUM_BOUNCER_ALTERNATIVE_SUBSCRIPTION_BUTTON]:
        'Out of Likes Platinum Bouncer Alternative Subscription Button',
      [HUBBLE_ID_MOBILE_SETTINGS_TINDER_PLATINUM_BUTTON]: 'Mobile Settings Tinder Platinum Button',
      [HUBBLE_ID_DESKTOP_SETTINGS_TINDER_PLATINUM_BUTTON]:
        'Desktop Settings Tinder Platinum Button',
      [HUBBLE_ID_RECS_SWIPE_LEFT]: 'Recs Swipe Left',
      [HUBBLE_ID_RECS_SWIPE_RIGHT]: 'Recs Swipe Right',
      [HUBBLE_ID_RECS_SWIPE_UP]: 'Recs Swipe Up',
      [HUBBLE_ID_RECS_REWIND_BUTTON]: 'Recs Rewind Button',
      [HUBBLE_ID_RECS_PASS_BUTTON]: 'Recs Pass Button',
      [HUBBLE_ID_RECS_SUPERLIKE_BUTTON]: 'Recs Superlike Button',
      [HUBBLE_ID_RECS_LIKE_BUTTON]: 'Recs Like Button',
      [HUBBLE_ID_RECS_BOOST_BUTTON]: 'Recs Boost Button',
      [HUBBLE_ID_RECS_CARD]: 'Recs Card',
      [HUBBLE_ID_RECS_CARD_PHOTO]: 'Recs Card Photo',
      [HUBBLE_ID_RECS_CARD_PHOTO_LEFT]: 'Recs Card Photo Left',
      [HUBBLE_ID_RECS_CARD_PHOTO_RIGHT]: 'Recs Card Photo Right',
      [HUBBLE_ID_RECS_CARD_PROFILE_BUTTON]: 'Recs Card Profile Button',
      [HUBBLE_ID_RECS_PROFILE_PASS_BUTTON]: 'Recs Profile Pass Button',
      [HUBBLE_ID_RECS_PROFILE_SUPERLIKE_BUTTON]: 'Recs Profile Superlike Button',
      [HUBBLE_ID_RECS_PROFILE_LIKE_BUTTON]: 'Recs Profile Like Button',
      [HUBBLE_ID_RECS_PROFILE_CLOSE_BUTTON]: 'Recs Profile Close Button',
      [HUBBLE_ID_RECS_PROFILE_CARD]: 'Recs Profile Card',
      [HUBBLE_ID_RECS_PROFILE_PHOTO]: 'Recs Profile Photo',
      [HUBBLE_ID_RECS_PROFILE_PHOTO_LEFT]: 'Recs Profile Photo Left',
      [HUBBLE_ID_RECS_PROFILE_PHOTO_RIGHT]: 'Recs Profile Photo Right',
      [HUBBLE_ID_GRID_ITEM_PROFILE_OPEN_BUTTON]: 'Grid Item Profile Open Button',
      [HUBBLE_ID_RECS_SCREEN]: 'Recs Screen',
      [HUBBLE_ID_EXPLORE_SCREEN]: 'Explore Screen',
      [HUBBLE_ID_PREMIUM_HOME_SCREEN]: 'Premium Home Screen',
      [HUBBLE_ID_CHAT_SCREEN]: 'Chat Screen',
      [HUBBLE_ID_DESKTOP_MATCHLIST_SCREEN]: 'Desktop Matchlist Screen',
      [HUBBLE_ID_MOBILE_MATCHLIST_SCREEN]: 'Mobile Matchlist Screen',
      [HUBBLE_ID_DESKTOP_PROFILE_SCREEN]: 'Desktop Profile Screen',
      [HUBBLE_ID_MOBILE_PROFILE_SCREEN]: 'Mobile Profile Screen',
      [HUBBLE_ID_RECS_CARDBOARD_SCREEN]: 'Recs Cardboard Screen',
      [HUBBLE_ID_RECS_PROFILE_SCREEN]: 'Recs Profile Screen',
      [HUBBLE_ID_MYLIKES_SCREEN]: 'MyLikes Screen',
      [HUBBLE_ID_LIKESSENT_SCREEN]: 'LikesSent Screen',
      [HUBBLE_ID_APPEAL_CENTER_BUTTON]: 'Appeal Center Button',
      [HUBBLE_ID_AUTH_COMPLETION_SCREEN]: 'Auth Completion Screen',
      [HUBBLE_ID_BAN_SCREEN]: 'Ban Screen',
      [HUBBLE_ID_COLLECT_EMAIL_SCREEN]: 'Collect Email Screen',
      [HUBBLE_ID_COLLECT_EMAIL_CONTINUE_BUTTON]: 'Collect Email Continue Button',
      [HUBBLE_ID_COLLECT_EMAIL_GOOGLE_BUTTON]: 'Collect Email Google Button',
      [HUBBLE_ID_CUSTOM_BAN_SCREEN]: 'Custom Ban Screen',
      [HUBBLE_ID_PHONE_NUMBER_SCREEN]: 'Phone Number Screen',
      [HUBBLE_ID_PHONE_NUMBER_CONTINUE_BUTTON]: 'Phone Number Continue Button',
      [HUBBLE_ID_PHONE_OTP_SCREEN]: 'Phone OTP Screen',
      [HUBBLE_ID_PHONE_OTP_CONTINUE_BUTTON]: 'Phone OTP Continue Button',
      [HUBBLE_ID_PUSH_AUTH_VERIFICATION_SCREEN]: 'Push Auth Verification Screen',
      [HUBBLE_ID_SIGN_IN_SCREEN]: 'Sign In Screen',
      [HUBBLE_ID_SIGN_IN_GOOGLE_BUTTON]: 'Sign In Google Button',
      [HUBBLE_ID_SIGN_IN_FACEBOOK_BUTTON]: 'Sign In Facebook Button',
      [HUBBLE_ID_SIGN_IN_PHONE_NUMBER_BUTTON]: 'Sign In Phone Number Button',
      [HUBBLE_ID_WELCOME_BACK_SCREEN]: 'Welcome Back Screen',
      [HUBBLE_ID_WELCOME_BACK_LOGIN_BUTTON]: 'Welcome Back Login Button',
      [HUBBLE_ID_WELCOME_BACK_TEXT]: 'Welcome Back Text',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_ENTRY]: 'Selfie V2 Challenge Entry',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_UNDER_REVIEW]: 'Selfie V2 Challenge Under Review',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_HOW_IT_WORKS]: 'Selfie V2 Challenge How It Works',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_DATA_EXPLANATION]: 'Selfie V2 Challenge Data Explanation',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_SELECTION]: 'Selfie V2 Challenge Consent Selection',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_EDUCATION]: 'Selfie V2 Challenge Education',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_CONNECTION_ERROR]: 'Selfie V2 Challenge Connection Error',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_ENTRY_CTA]: 'Selfie V2 Challenge Entry CTA',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_1_CTA]: 'Selfie V2 Challenge Info 1 CTA',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_1_EXIT]: 'Selfie V2 Challenge Info 1 Exit',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_2_CTA]: 'Selfie V2 Challenge Info 2 CTA',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_2_EXIT]: 'Selfie V2 Challenge Info 2 Exit',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_2_PREVIOUS]: 'Selfie V2 Challenge Info 2 Previous',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_INFO_MORE_DETAILS]: 'Selfie V2 Challenge Info More Details',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_CTA]: 'Selfie V2 Challenge Consent CTA',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_PREVIOUS]: 'Selfie V2 Challenge Consent Previous',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_EXIT]: 'Selfie V2 Challenge Consent Exit',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_CONSENT_LEARN_MORE]: 'Selfie V2 Challenge Consent Learn More',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_EDUCATION_START]: 'Selfie V2 Challenge Education Start',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_EDUCATION_EXIT]: 'Selfie V2 Challenge Education Exit',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_FACE_TEC_USER_CANCEL]:
        'Selfie V2 Challenge Face Tec User Cancel',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_FACE_TEC_INITIALIZED]:
        'Selfie V2 Challenge Face Tec Initialized',
      [HUBBLE_ID_SELFIE_V2_CHALLENGE_FACE_TEC_SUCCESS]: 'Selfie V2 Challenge Face Tec Success',
      [HUBBLE_ID_MANDATED_FACE_PHOTO_PROFILE_WARNING]: 'Mandated Face Photo Profile Warning',
      [HUBBLE_ID_MANDATED_FACE_PHOTO_PROFILE_WARNING_TAP]:
        'Mandated Face Photo Profile Warning Tap',
      [HUBBLE_ID_MANDATED_FACE_PHOTO_LEARN_MORE_BUTTON]: 'Mandated Face Photo Learn More Button',
      [HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL]: 'Mandated Face Photo Bouncer Modal',
      [HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL_ADD_PHOTO_BUTTON]:
        'Mandated Face Photo Bouncer Modal Add Photo Button',
      [HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL_DISMISS_BUTTON]:
        'Mandated Face Photo Bouncer Modal Dismiss Button',
      [HUBBLE_ID_MANDATED_FACE_PHOTO_BOUNCER_MODAL_LEARN_MORE_BUTTON]:
        'Mandated Face Photo Bouncer Modal Learn More Button',
      [HUBBLE_ID_ONBOARDING_AGE_RESTRICTED]: 'Onboarding Age Restricted',
      [HUBBLE_ID_ONBOARDING_BIRTHDAY]: 'Onboarding Birthday',
      [HUBBLE_ID_ONBOARDING_DISTANCE_PREFERENCE]: 'Onboarding Distance Preference',
      [HUBBLE_ID_ONBOARDING_GENDER]: 'Onboarding Gender',
      [HUBBLE_ID_ONBOARDING_HOUSE_RULES]: 'Onboarding House Rules',
      [HUBBLE_ID_ONBOARDING_INTERESTS]: 'Onboarding Interests',
      [HUBBLE_ID_ONBOARDING_LIFESTYLE_HABITS]: 'Onboarding Lifestyle Habits',
      [HUBBLE_ID_ONBOARDING_NAME]: 'Onboarding Name',
      [HUBBLE_ID_ONBOARDING_COMPLETION]: 'Onboarding Completion',
      [HUBBLE_ID_ONBOARDING_EXIT_MODAL]: 'Onboarding Exit Modal',
      [HUBBLE_ID_ONBOARDING_EXIT_MODAL_STAY_BUTTON]: 'Onboarding Exit Modal Stay Button',
      [HUBBLE_ID_ONBOARDING_EXIT_MODAL_LEAVE_BUTTON]: 'Onboarding Exit Modal Leave Button',
      [HUBBLE_ID_ONBOARDING_STARTED]: 'Onboarding Started',
      [HUBBLE_ID_ONBOARDING_PHOTOS]: 'Onboarding Photos',
      [HUBBLE_ID_ONBOARDING_RELATIONSHIP_INTENT]: 'Onboarding Relationship Intent',
      [HUBBLE_ID_ONBOARDING_SCHOOL]: 'Onboarding School',
      [HUBBLE_ID_ONBOARDING_SEXUAL_ORIENTATION]: 'Onboarding Sexual Orientation',
      [HUBBLE_ID_ONBOARDING_TARGET_GENDER]: 'Onboarding Target Gender',
      [HUBBLE_ID_ONBOARDING_SUBMIT_BUTTON]: 'Onboarding Submit Button',
      [HUBBLE_ID_ONBOARDING_SKIP_BUTTON]: 'Onboarding Skip Button',
      [HUBBLE_ID_ONBOARDING_BACK_BUTTON]: 'Onboarding Back Button',
    }
  : {};
